import { SizeEnum } from './size-enum.esm.js';

function isSizeKey(key) {
  return Object.keys(SizeEnum).includes(key);
}

export { isSizeKey };
//# sourceMappingURL=types.esm.js.map
